import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { DeleteIcon, InfoIcon, MenuItem, SelectionIcon, ShareLinkIcon, ViewerIcon } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useMarkupMoreOptions } from "@pages/project-details/project-markups/use-markup-more-options";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { toggleItemSelection } from "@utils/array-utils";
/** Three-dots menu of a markup in the list of small screens */
export function MarkupListItemMenuMobile(t0) {
  const $ = _c(31);
  const {
    markup
  } = t0;
  const dispatch = useAppDispatch();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t1;
  if ($[0] !== markup) {
    t1 = {
      markup
    };
    $[0] = markup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    openMarkup,
    viewDetails,
    shareMarkup,
    canDeleteMarkup,
    requestDeleteMarkup,
    deleteDialog
  } = useMarkupMoreOptions(t1);
  let t2;
  if ($[2] !== dispatch || $[3] !== markup || $[4] !== selectedRowIds) {
    t2 = {
      label: "Select",
      Icon: SelectionIcon,
      onSelect: () => dispatch(setInitialFetchingItems(toggleItemSelection(selectedRowIds, markup.id)))
    };
    $[2] = dispatch;
    $[3] = markup;
    $[4] = selectedRowIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== openMarkup) {
    t3 = {
      label: "Open",
      Icon: ViewerIcon,
      onSelect: openMarkup
    };
    $[6] = openMarkup;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== viewDetails) {
    t4 = {
      label: "View details",
      Icon: InfoIcon,
      onSelect: viewDetails
    };
    $[8] = viewDetails;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== shareMarkup) {
    t5 = {
      label: "Share",
      Icon: ShareLinkIcon,
      onSelect: shareMarkup,
      shouldShowDividerAfter: true
    };
    $[10] = shareMarkup;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== canDeleteMarkup) {
    t6 = () => canDeleteMarkup;
    $[12] = canDeleteMarkup;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== requestDeleteMarkup) {
    t7 = (_, onMenuClose) => <MenuItem label="Delete" Icon={DeleteIcon} color="error.main" highlightColor="error.main" onClick={() => {
      onMenuClose();
      requestDeleteMarkup();
    }} />;
    $[14] = requestDeleteMarkup;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = {
      label: "Delete",
      Icon: DeleteIcon,
      shouldShow: t6,
      component: t7
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t3, t4, t5, t8];
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const menuItems = t9;
  let t10;
  if ($[25] !== markup || $[26] !== menuItems) {
    t10 = <ListItemMenu item={markup} menuItems={menuItems} />;
    $[25] = markup;
    $[26] = menuItems;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== deleteDialog || $[29] !== t10) {
    t11 = <Box onClick={_temp} onKeyDown={_temp2}>{t10}{deleteDialog}</Box>;
    $[28] = deleteDialog;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}